import common from './en/common';
import auth from './en/auth';
import home from './en/home';
import navBar from './en/navBar';
import projet from './en/projet';
import parametre from './en/parametre';
import logs from './en/logs';
import database from './en/database';
import maps from './en/map';
import user from './en/user';
import form from './en/form';
import customer from './en/customer';
import counterPlace from './en/counterPlace';

export default {
  ...common,
  ...auth,
  ...home,
  ...navBar,
  ...projet,
  ...parametre,
  ...logs,
  ...database,
  ...maps,
  ...user,
  ...form,
  ...customer,
  ...counterPlace,
};
